import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Close from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Form as Formm } from "react-form";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import TimelineIcon from "@material-ui/icons/Timeline";
import ShowChartIcon from "@material-ui/icons/ShowChart";
import ViewHeadlineIcon from "@material-ui/icons/ViewHeadline";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import AddIcon from "@material-ui/icons/Add";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import drag from "../../common/icons/dnd.png";
import { ColorPicker as MuiColorPicker } from "material-ui-color";
import Checkbox from "../../common/Checkbox";
import WarningDialog from "../../common/WarningDialog";
import ColorPicker from "../../common/ColorPicker";
import NativeSelect from "@material-ui/core/NativeSelect";
import { createSelector } from "../../common/orm";
import { RecordSection, PageAnalytics, AnalyticsGroup } from "../models";
import ReactSelect from "../../common/ReactSelect";
import HelpLabel from "../../common/HelpLabel";
import Select from "../../common/Select";
import TextField from "../../common/TextField";
import Switch from "../../common/Switch";

const styles = (theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: "auto",
    },
    root1: {
        width: "100%",
        overflowX: "auto",
        backgroundColor: "#f0f0f0",
        minWidth: 596,
    },
    scroller: {
        width: "100%",
        overflowX: "hidden",
    },
    fullWidth: {
        flexGrow: 1,
        maxWidth: "none",
        flexBasis: 0,
        flexShrink: 1,
    },

    dialogMin: {
        minWidth: 600,
        padding: 0,
    },
    flex: {
        flex: 1,
    },
    maxHeight: {
        width: 1150,
        maxWidth: "calc(100vw - 32px)",
        minHeight: "min(800px, calc(100vh - 32px))",
    },
    maxHeightDynamic: {
        width: 1150,
        maxWidth: "calc(100vw - 32px)",
    },
    table: {
        minWidth: 500,
    },
    deleteWidth: {
        minWidth: 34,
        width: 34,
        margin: "0 8px 0 0",
    },
    centerAlign: {
        textAlign: "center",
    },
    minWidth2: {
        minWidth: 605,
        minheight: 685,
    },
    colorPickerCenter: {
        '& > div': {
            alignItems: 'center',
        },
        '& [data-testid="colorpicker-noinput"]': {
            display: 'flex',
            alignItems: 'center',
        },
    },
    iconAdd: {
        backgroundColor: "#34aa20",
        color: "white",
        height: "25px",
        width: "25px",
        paddingTop: "0px",
        fontSize: "100%",
        borderRadius: 12,
    },
});
const getGeometry = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["id"]),
    (session, pageID) => {
        return session.Section.filter((sect) => sect.page === pageID && sect.has_geometry).count() > 0;
    }
);

const getPageAnalytics = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["advID"]),
    (session, advID) => {
        return session.AdvancedSearch.filter((a) => a.id === advID)
            .toModelArray()
            .map((advancedsearch) => ({
                pageanalytics: advancedsearch.pageanalytics.all().orderBy("order").toRefArray(),
                ...advancedsearch.ref,
            }));
    }
);

const getAllContactFields = createSelector((schema) => {
    return schema.ContactField.all().orderBy("order").toModelArray();
});

const getAnalyticsGroups = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["id"]),
    (session, pageID) => {
        return session.AnalyticsGroup.filter((g) => g.page === pageID)
            .orderBy("order")
            .toModelArray()
            .map((group) => ({
                cards: group.pageanalytics
                    .all()
                    .toModelArray()
                    .filter((c) => c.advancedsearch)
                    .sort((a, b) => a.order - b.order)
                    .map((c) => ({
                        search_name: c.advancedsearch.ref.name,
                        search_page: pageID,
                        ...c.ref,
                    })),
                ...group.ref,
            }));
    }
);

//fields styling section for groups
const getItemStyle2 = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: 1,
    margin: `6px 14px 6px 14px`,
    color: "primary",
    fontSize: "18px",
    borderRadius: 5,
    textAlign: "left",
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 2px, rgba(0, 0, 0, 0.25) 0px 2px 2px",

    // change background of fields when dragging
    background: isDragging ? "lightgrey" : "lightgrey",

    // styles we need to apply on draggables
    ...draggableStyle,
});

// background color on "fields child card" section when dragging
const getListStyle2 = (isDraggingOver) => ({
    background: isDraggingOver ? "#4e4e4e" : "",
    borderRadius: 5,
    marginBottom: isDraggingOver ? 80 : 30,
});

class AdvancedSearchSettings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: 0,
            modifiedFields: null,
            open_analytic: false,
            analyticToEdit: null,
            analyticFields: null,
            analyticFields2: null,
            chartOptions: false,
            chart_Type: "",
            statType: ["Count", "Average", "Sum", "Min", "Max"],
            key: window.performance.now(),
            fieldType: null,
            deleteDialogOpen: false,
            analyticToDelete: null,
            showCards: false,
            createGroupDialogOpen: false,
            newGroupName: '',
            renameGroupOpen: false,
            groupToRename: null,
            renameGroupValue: '',
            renameGroupColor: '',
            renameGroupFontColor: '',
            deleteGroupDialogOpen: false,
            groupToDelete: null,
        };
    }

    saveSettings = (e) => {
        const {
            ormAdvancedGroupCreate,
            ormAdvancedGroupUpdate,
            ormAdvancedTableFieldsCreate,
            ormAdvancedTableFieldsDelete,
            ormAdvancedTableFieldsUpdate,
            ormAdvancedSearchUpdate,
            advancedsearchID,
            advancedtablefields,
            authState,
            advancedgroups,
            page,
            history,
        } = this.props;

        const group = advancedgroups.find((g) => {
            return g.name === e.group_name;
        });

        if (e.geo_color)
            for (const i in e) {
                if (i === "geo_color") {
                    ormAdvancedSearchUpdate({
                        id: advancedsearchID[0].id,
                        geo_color: e[i],
                    });
                }
            }

        // all fields for statistics all are deleted so clear all 'selection is empty'
        if (e.columnField === "") {
            if (advancedtablefields.length > 0) {
                advancedtablefields.forEach((f) => {
                    ormAdvancedTableFieldsDelete(f.id);
                });
                this.props.handleDialog(); //close dialog
            }
        }
        //all columns to show on the table allows deletion and addition of columns
        if (e.columnField) {
            //get all field ids and put into one array split by commas
            let cols = e.columnField.split(",");

            //delete from DB if not selected anymore, search current db values
            if (advancedtablefields.length > 0) {
                advancedtablefields.forEach((f) => {
                    var found = cols.find((field) => {
                        return parseInt(field) === f.field || parseInt(field.replace("c_", "")) === f.contact_field;
                    });
                    if (!found) {
                        ormAdvancedTableFieldsDelete(f.id);
                    }
                });

                this.props.handleDialog(); //close dialog
            }

            //remove stat fields from cols as we dont want to double keys in db
            if (e.statisticField) var stat = e.statisticField.split(",");
            if (stat) {
                for (var i = 0; i < cols.length; i++) {
                    for (var s = 0; s < stat.length; s++) {
                        if (stat[s] === cols[i]) {
                            cols.splice(cols.indexOf(stat[s]), 1);
                        }
                    }
                }
            }

            //create a record in DB if its not there
            cols.forEach((fieldID, idx) => {
                if (fieldID.includes("c_")) {
                    var contactField = fieldID.replace("c_", "");
                    let found = advancedtablefields.find((f) => {
                        return f.contact_field === parseInt(contactField);
                    });
                    //if not in database create else skip
                    if (!found) {
                        ormAdvancedTableFieldsCreate({
                            advancedsearch_id: advancedsearchID[0].id,
                            contact_field_id: parseInt(contactField),
                            order: idx,
                        });
                    } else {
                        //we update 'ordering' again to match current layout
                        ormAdvancedTableFieldsUpdate({
                            id: found.id,
                            contact_field_id: parseInt(contactField),
                            order: idx,
                        });
                    }
                } else {
                    let found = advancedtablefields.find((f) => {
                        return f.field === parseInt(fieldID);
                    });
                    //if not in database create else skip
                    if (!found) {
                        ormAdvancedTableFieldsCreate({
                            advancedsearch_id: advancedsearchID[0].id,
                            field_id: parseInt(fieldID),
                            order: idx,
                        });
                    } else {
                        //we update 'ordering' again to match current layout
                        ormAdvancedTableFieldsUpdate({
                            id: found.id,
                            field_id: parseInt(fieldID),
                            order: idx,
                        });
                    }
                }
            });
        }

        // fields for statistics all are deleted so clear all 'selection is empty'
        if (e.statisticField === "") {
            if (advancedtablefields.length > 0) {
                advancedtablefields.forEach((f) => {
                    ormAdvancedTableFieldsUpdate({ id: f.id, statistics: false });
                });
                this.props.handleDialog(); //close dialog
            }
        }

        // will be hit for >= 1 field for statistics
        if (e.statisticField) {
            let stat = e.statisticField.split(",");

            //delete from DB if not selected anymore, search current db values
            if (advancedtablefields.length > 0) {
                advancedtablefields.forEach((f) => {
                    let found = stat.find((field) => {
                        return parseInt(field) === f.field;
                    });
                    if (!found) {
                        ormAdvancedTableFieldsUpdate({ id: f.id, statistics: false });
                    }
                });
                this.props.handleDialog(); //close dialog
            }
            //create a record in DB if its not there
            stat.forEach((fieldID) => {
                let found = advancedtablefields.find((f) => {
                    return f.field === parseInt(fieldID);
                });

                //if not in database create else update
                if (!found) {
                    ormAdvancedTableFieldsCreate({
                        advancedsearch_id: advancedsearchID[0].id,
                        field_id: fieldID,
                        statistics: true,
                        order: advancedtablefields.length,
                    });
                } else if (!found.statistics)
                    ormAdvancedTableFieldsUpdate({ advancedsearch_id: advancedsearchID[0].id, id: found.id, field_id: fieldID, statistics: true });
            });
        }

        //permissions
        if (e.g_name) {
            // new group name added and assigned to this search
            ormAdvancedGroupCreate({
                page: group.page,
                name: e.g_name,
                expansion_color: e.expansion_color,
                expansion_font_color: e.expansion_font_color,
            }).then((g) => {
                //group already created
                ormAdvancedSearchUpdate({
                    id: advancedsearchID[0].id,
                    advancedgroup: g.id,
                    accessby: e.accessby,
                    accesscreatorid: e.accessby !== 'All Including External Read Only Users' ? authState.user.id : null,
                    editableby: e.editableby,
                    editcreatorid: e.editableby !== 'All Except External Read Only Users' ? authState.user.id : null,
                    dashboard: e.dashboard,
                    geometriesonmap: e.geometriesonmap,
                    showlatloncolumns: e.showlatloncolumns
                });
                this.props.handleDialog();
            });
        } else if (group) {
            //group already created just update params
            ormAdvancedGroupUpdate({
                id: group.id,
                expansion_color: e.expansion_color,
                expansion_font_color: e.expansion_font_color,
            });
            ormAdvancedSearchUpdate({
                id: advancedsearchID[0].id,
                advancedgroup: group.id,
                accessby: e.accessby,
                accesscreatorid: e.accessby !== 'All Including External Read Only Users' ? authState.user.id : null,
                editableby: e.editableby,
                editcreatorid: e.editableby !== 'All Except External Read Only Users' ? authState.user.id : null,
                dashboard: e.dashboard,
                geometriesonmap: e.geometriesonmap,
                showlatloncolumns: e.showlatloncolumns
            });

            this.props.handleDialog();

            history.push("/page/" + page[0].id + "/advancedsearch/" + advancedsearchID[0].id);
        }
        this.props.handleDialog();
    };

    //page analytic saving of all fields
    saveAnalytic = (values) => {
        const { analyticToEdit } = this.state;
        const { ormPageAnalyticsUpdate } = this.props;

        values.field = parseInt(values.field);
        if (values.goal_value === " ") values.goal_value = 0;
        if (values.field === " ") values.field = 0;
        if (values.field2 === " ") values.field2 = 0;

        //delete these keys as are only saved on selection of field for analytic
        values.field2_type = undefined;
        values.field_type = undefined;

        ormPageAnalyticsUpdate({ id: analyticToEdit.id, ...values });
        this.setState({ open_analytic: false });
    };

    errorValidator = (values) => { };

    //page analytics fields for defaults
    defaultAnalytic = (e) => {
        const { advancedtablefields, allFields } = this.props;
        const { analyticToEdit, modifiedFields, statType, chartOptions, analyticFields, analyticFields2 } = this.state;
        var obj = {};
        var defaultValues = [];

        //get default value of fields for react-selects for analytics
        if (e === "AnalyticField" || e === "AnalyticField2") {
            //we update the analytic fields if they changed on the columns & then only push the selected
            let temp = [];
            advancedtablefields.forEach((f) => {
                allFields.forEach((j) => {
                    j.form.forEach((k) => {
                        k.groups.forEach((g) => {
                            g.fields.forEach((fi) => {
                                if (fi.id === f.field) {
                                    if (e === "AnalyticField") {
                                        if (fi.id === analyticToEdit.field) defaultValues.push({ label: fi.name, value: f.field, type: fi.type });
                                        temp.push({ label: fi.name, value: f.field, type: fi.type });
                                    } else if (e === "AnalyticField2") {
                                        if (fi.id === analyticToEdit.field2) defaultValues.push({ label: fi.name, value: f.field, type: fi.type });
                                        if (fi.type === "Date") temp.push({ label: fi.name, value: f.field, type: fi.type });
                                    }
                                }
                            });
                        });
                    });
                });
            });
            // cards from other searches may reference fields that aren't columns on
            // this search's results table -- fall back to the page-wide field list
            // just to resolve a display label/type for the existing selection
            if (defaultValues.length === 0 && analyticToEdit) {
                const targetFieldId = e === "AnalyticField" ? analyticToEdit.field : analyticToEdit.field2;
                if (targetFieldId) {
                    modifiedFields.forEach((mf) => {
                        mf.options.forEach((opt) => {
                            if (opt.value === targetFieldId) defaultValues.push({ label: opt.label, value: opt.value, type: opt.type });
                        });
                    });
                }
            }

            const seenVals = new Set();
            const dedupedTemp = temp.filter(item => seenVals.has(item.value) ? false : seenVals.add(item.value));
            if (e === "AnalyticField") {
                if (dedupedTemp.length !== analyticFields.length) this.setState({ analyticFields: dedupedTemp });
            } else if (dedupedTemp.length !== analyticFields2.length) this.setState({ analyticFields2: dedupedTemp });

            return defaultValues;
        }

        // get all other analytic fields
        if (analyticToEdit) obj = { ...analyticToEdit };

        // default the value text color to black for cards that don't have one set yet
        if (!obj.stat_color) obj.stat_color = "#000000";

//set the statistic types that can be selected based on field type
        if (obj.field) {
            var field;
            modifiedFields.forEach((mf) => {
                mf.options.find((f) => {
                    return f.value === obj.field ? (field = f) : "";
                });
            });

            if (
                field &&
                field.type !== "Incremental" &&
                field.type !== "Numeric" &&
                field.type !== "Calculated" &&
                field.type !== "Currency" &&
                statType.length !== 1
            ) {
                this.setState({ statType: ["Count"] });
            } else if (
                field &&
                (field.type === "Incremental" || field.type === "Numeric" || field.type === "Calculated" || field.type === "Currency") &&
                statType.length === 1
            ) {
                this.setState({ statType: ["Count", "Average", "Sum", "Min", "Max"] });
            }
        }

        return obj;
    };

    defaultValues = (e) => {
        if (this.props.moduleAnalyticsOnly) return e ? [] : {};
        const { advancedtablefields, advancedsearchID, advancedgroups } = this.props;
        const { modifiedFields, showCards } = this.state;

        var obj = {};
        var defaultValues = [];

        //get all database fields that were previously saved, this runs for both ReactSelects with their default calls
        if (e === "columnField" || e === "statisticField") {
            // eslint-disable-next-line
            advancedtablefields.forEach((f) => {
                // eslint-disable-next-line
                modifiedFields.find((j) => {
                    // eslint-disable-next-line
                    j.options.find((k) => {
                        if ((k.value === f.field || k.value === "c_" + f.contact_field) && e === "columnField") {
                            defaultValues.push(k);
                        } else if (k.value === f.field && f.statistics && e === "statisticField") {
                            defaultValues.push(k);
                        }
                    });
                });
            });
            // if(advancedsearchID && advancedsearchID.length > 0){
            //     defaultValues.push({"showlatloncolumns":advancedsearchID[0].showlatloncolumns})
            // }
            return defaultValues;
        }
        var group = advancedgroups.find((g) => {
            return g.id === advancedsearchID[0].advancedgroup;
        });

        obj["group_name"] = group.name;
        obj["expansion_color"] = group.expansion_color;
        obj["expansion_font_color"] = group.expansion_font_color;
        obj["editableby"] = advancedsearchID[0].editableby;
        obj["accessby"] = advancedsearchID[0].accessby;
        obj["dashboard"] = advancedsearchID[0].dashboard;
        obj["geo_color"] = advancedsearchID[0].geo_color;
        obj["analytics_view"] = advancedsearchID[0].analytics_view;
        obj["geometriesonmap"] = advancedsearchID[0].geometriesonmap;
        obj["showlatloncolumns"] = advancedsearchID[0].showlatloncolumns;
        if (advancedsearchID[0].analytics_view && !showCards) this.setState({ showCards: true });

        return obj;
    };

    componentDidMount() {
        // //get all forms & fields that are for parent and user chosen section
        if (this.props.moduleAnalyticsOnly) {
            this.setState({ value: 2, showCards: true });
        }

        const { allFields, /* sections, advancedsearchID, */ contact_fields, advancedtablefields } = this.props;
        const { modifiedFields } = this.state;
        //find parent section
        // var parent = sections.find((s) => {
        //     if (s.parent) {
        //         return s;
        //     } else return null;
        // });
        // var allForms = allFields.filter((p) => {
        //     if (p.id === parent.id || p.id === advancedsearchID[0].section || p.is_master_contact_form) {
        //         return p;
        //     } else return null;
        // });
        // //get all forms for parent and user chosen section
        var allFormFields = [];

        /*if (authState.user.city_id === 10 && advancedsearch[0].section !== parent.id)*/ var allForms = allFields; //beta for crwd multisections

        //get all fields, setup object so that is can be read into reactSelect as an optGroup.
        //ex. obj ({label: labelName, options:[{key:value}]), label is groupName with options being an array of fields.
        allForms.forEach((c) => {
            if (c.form.length > 0) {
                c.form.forEach((f) => {
                    let temparray = [];
                    f.groups.forEach((g) => {
                        g.fields.forEach((k) => {
                            temparray.push({ label: k.name + " (" + g.name + ")", value: k.id, type: k.type }); //push 'props' that are same 'name' as label and value for optgroup--select.js.These are the items
                        });
                    });
                    let form = { label: f.name + " (Section " + c.name + ")", options: temparray }; //push values into a new array with items. We know have all props for "select.js" optGroup case
                    allFormFields.push(form);
                });
            }
            if (c.is_master_contact_form) {
                //rerendering of window or reopening search add contacts column fields if available
                let temparray = [];
                contact_fields.forEach((k) => {
                    temparray.push({ label: k.field_name, value: "c_" + k.id });
                });
                let form = { label: "Contacts (Section " + c.name + ")", options: temparray };
                allFormFields.push(form);
            }
        });

        if (modifiedFields === null || modifiedFields.length !== allFormFields.length) {
            //get only the selected columns for page analytics as we do not want users to be trying to grab non-queried fields
            var analyticfields = [];
            var analyticFields2 = [];
            advancedtablefields.forEach((f) => {
                // eslint-disable-next-line
                allFormFields.find((j) => {
                    // eslint-disable-next-line
                    j.options.find((k) => {
                        if (k.value === f.field) {
                            analyticfields.push(k);
                        }
                        if (k.value === f.field && k.type === "Date") analyticFields2.push(k);
                    });
                });
            });

            const dedup = (arr) => {
                const seen = new Set();
                return arr.filter(item => { const k = item.value; return seen.has(k) ? false : seen.add(k); });
            };
            //initially and update when section is chosen to update all forms with fields
            this.setState({
                modifiedFields: [...new Set(allFormFields)],
                analyticFields: dedup(analyticfields),
                analyticFields2: dedup(analyticFields2),
            });
        }
    }

    componentDidUpdate(prevProps) {
        const { advancedsearchID, formFields, moduleAnalyticsOnly } = this.props;
        const { modifiedFields } = this.state;

        //update only on initial selection of advancedfilter section to make sure we have all forms fields/sections
        if (advancedsearchID && advancedsearchID[0] && advancedsearchID[0].section && formFields && formFields.length !== modifiedFields.length)
            this.setState({ modifiedFields: formFields, key: window.performance.now() });

        // when opened as a module-analytics-only shortcut, jump straight to that tab and ensure cards are visible
        if (!prevProps.open && this.props.open && moduleAnalyticsOnly)
            this.setState({ value: 2, showCards: true });
    }

    //value function for dropdown datatype. This is the options property.
    dropDownValues = (table) => {
        return table.map((row) => ({
            label: row,
            value: row,
        }));
    };
    dropDownColorValues = (table) => {
        return table.map((row) => ({
            label: row.color,
            value: `${row.color},${row.hex}`,
        }));
    };

    chartType = (type) => {
        return type.map((thistype) => ({
            label: thistype,
            value: thistype,
        }));
    };

    timeSeries = (type) => {
        return type.map((t) => ({
            label: t,
            value: t,
        }));
    };

    //update color of expansion bar if a prior group was choosen
    relay = (e) => {
        const { advancedgroups } = this.props;

        const found = advancedgroups.find((g) => {
            return g.name === e.target.value;
        });
        this.formApi.setValue("group_name", e.target.value);
        this.formApi.setValue("expansion_color", found.expansion_color);
    };

    onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const { ormPageAnalyticsUpdate, advancedsearch } = this.props;
        // // analytics
        if (result.destination.droppableId === "analytics_list") {
            const pageanalytics = advancedsearch[0].pageanalytics;
            // Set the order of analytics moved between starting and ending position
            pageanalytics.forEach(function (p) {
                // If the destination is greater than the original position then shift all items between them down 1
                // result.source.index = 0
                // result.destination.index = 2
                if (result.destination.index > result.source.index) {
                    if (p.order > result.source.index && p.order <= result.destination.index) {
                        ormPageAnalyticsUpdate({
                            id: p.id,
                            order: p.order - 1,
                        });
                    }
                }
                // If the destination is less than the original position then shift all items between them up 1
                // result.source.index = 2
                // result.destination.index = 0
                else if (result.destination.index < result.source.index) {
                    if (p.order >= result.destination.index && p.order < result.source.index) {
                        ormPageAnalyticsUpdate({
                            id: p.id,
                            order: p.order + 1,
                        });
                    }
                }
            });
            // Set the order of analytics moved
            ormPageAnalyticsUpdate({
                id: result.draggableId,
                order: result.destination.index,
            });
        }
    };

    handleCreateGroup = () => {
        const { analyticsGroups } = this.props;
        const { newGroupName } = this.state;
        if (!newGroupName.trim()) return;
        this.props.ormAnalyticsGroupCreate({
            page: parseInt(this.props.match.params["id"]),
            name: newGroupName.trim(),
            order: analyticsGroups.length,
        });
        this.setState({ createGroupDialogOpen: false, newGroupName: '' });
    };

    handleRenameGroup = () => {
        const { groupToRename, renameGroupValue, renameGroupColor, renameGroupFontColor } = this.state;
        if (!renameGroupValue.trim()) return;
        this.props.ormAnalyticsGroupUpdate({ id: groupToRename.id, name: renameGroupValue.trim(), header_color: renameGroupColor || null, header_font_color: renameGroupFontColor || null });
        this.setState({ renameGroupOpen: false, groupToRename: null, renameGroupValue: '', renameGroupColor: '', renameGroupFontColor: '' });
    };

    handleDeleteGroup = () => {
        const { analyticsGroups } = this.props;
        const { groupToDelete } = this.state;
        const defaultGroup = analyticsGroups.find((g) => g.name === 'Module Analytics');
        groupToDelete.cards.forEach((card) => {
            this.props.ormPageAnalyticsUpdate({
                id: card.id,
                analytics_dashboard_group: defaultGroup ? defaultGroup.id : null,
            });
        });
        this.props.ormAnalyticsGroupDelete(groupToDelete.id);
        this.setState({ deleteGroupDialogOpen: false, groupToDelete: null });
    };

    handleGroupDragEnd = (result, groupCards) => {
        if (!result.destination) return;
        const { ormPageAnalyticsUpdate } = this.props;
        const reordered = Array.from(groupCards);
        const [moved] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, moved);
        reordered.forEach((card, index) => {
            if (card.order !== index) {
                ormPageAnalyticsUpdate({ id: card.id, order: index });
            }
        });
    };

    render() {
        const {
            classes,
            open,
            advancedgroups,
            advancedsearchID,
            ormPageAnalyticsCreate,
            advancedsearch,
            ormAdvancedSearchUpdate,
            ormPageAnalyticsDelete,
            ormPageAnalyticsUpdate,
            authState,
            has_geometry,
            sections,
        } = this.props;
        const {
            value,
            modifiedFields,
            open_analytic,
            analyticFields,
            analyticFields2,
            showCards,
            chartOptions,
            analyticToEdit,
            analyticToDelete,
            statType,
            chart_Type,
            key,
            deleteDialogOpen,
            createGroupDialogOpen,
            newGroupName,
            renameGroupOpen,
            groupToRename,
            renameGroupValue,
            renameGroupColor,
            renameGroupFontColor,
            deleteGroupDialogOpen,
            groupToDelete,
        } = this.state;
        const { analyticsGroups = [], moduleAnalyticsOnly } = this.props;

        const edit_access = ["Creator", "Admin", "All", "All Except External Read Only Users"];
        const accessibility = ["Creator", "Admin", "All", "All Including External Read Only Users"];
        const chartTypes = ["None", "Gauge", "Time Series"];
        const timeSeriesType = ["Bar", "Line"];
        const timeToIncrement = ["Daily", "Weekly", "Monthly", "Quarterly", "Annually"];
        const tableData = advancedsearch;
        let isPointGeo = false
        if (sections) {
            isPointGeo = sections.some(s => s.geometry_type === 'Point');
        }

        let dynamicPaperProps = {};
        if (moduleAnalyticsOnly) {
            const BASE = 200;       // toolbar + footer text + outer padding
            const PER_GROUP = 95;   // accordion header + column header row
            const PER_CARD = 46;    // each card row
            const totalCards = analyticsGroups.reduce((sum, g) => sum + g.cards.length, 0);
            const desired = BASE + analyticsGroups.length * PER_GROUP + totalCards * PER_CARD;
            const computedHeight = `min(max(280px, ${desired}px), calc(100vh - 32px))`;
            dynamicPaperProps = { style: { height: computedHeight, minHeight: 280, maxHeight: "calc(100vh - 32px)" } };
        }

        return (
            <div className={classes.root}>
                <Dialog open={open} maxWidth="md" fullWidth classes={{ paper: moduleAnalyticsOnly ? classes.maxHeightDynamic : classes.maxHeight }} PaperProps={dynamicPaperProps}>
                    <Toolbar style={{ backgroundColor: "#d3d3d3", marginBottom: -8, position: "sticky", top: 0, zIndex: 10 }}>
                        <Typography variant="h5" className={classes.flex}>
                            {moduleAnalyticsOnly ? "Module Analytics" : "Saved Search Settings"}
                        </Typography>
                        <IconButton onClick={this.props.handleDialog}>
                            <Close />
                        </IconButton>
                    </Toolbar>
                    <DialogContent className={classes.dialogMin}>
                        <DialogContentText>
                            <Formm
                                key={key}
                                getApi={(el) => (this.formApi = el)} //allows use of this.formApi ref external of form
                                // dontValidateOnMount="true"
                                validateOnSubmit="true"
                                defaultValues={this.defaultValues()}
                                onSubmit={(values) => this.saveSettings(values)}
                                onSubmitFailure={() => { }}>
                                {(formApi) => (
                                    <form onSubmit={formApi.submitForm}>
                                        {!moduleAnalyticsOnly && (
                                            <div>
                                                <AppBar position="static" color="default">
                                                    <Tabs
                                                        value={value}
                                                        onChange={(event, value) => {
                                                            this.setState({ value });
                                                        }}
                                                        variant="scrollable"
                                                        indicatorColor="primary"
                                                        textColor="primary"
                                                        classes={{ scroller: classes.scroller }}>
                                                        <Tab
                                                            classes={{ root: classes.fullWidth }}
                                                            icon={<ViewHeadlineIcon />}
                                                            label={"Result Table Display"}
                                                            value={0}
                                                        />
                                                        <Tab
                                                            classes={{ root: classes.fullWidth }}
                                                            icon={<TimelineIcon />}
                                                            label={"Statistic Fields"}
                                                            value={1}
                                                        />
                                                        <Tab
                                                            classes={{ root: classes.fullWidth }}
                                                            icon={<ShowChartIcon />}
                                                            label={"Module Analytics"}
                                                            value={2}
                                                        />
                                                        <Tab
                                                            classes={{ root: classes.fullWidth }}
                                                            icon={<SupervisorAccountIcon />}
                                                            label={"View Settings"}
                                                            value={3}
                                                        />
                                                    </Tabs>
                                                </AppBar>
                                            </div>
                                        )}
                                        {value === 0 && (
                                            <Grid container style={{ paddingTop: 20, paddingLeft: 16, paddingRight: 16 }}>
                                                <Grid item xs={12}>
                                                    <Typography variant="h5"

                                                        className={classes.flex}><>
                                                            Column Fields
                                                            <HelpLabel expansionPanel={true} helpText={"The <b>selection</b> ordering of the fields will follow the same order within the table results of the search.<br/><br/>\
                                                            "} /></>

                                                    </Typography>
                                                    {/* default values are passed to the reactSelect component for rendering*/}
                                                    <ReactSelect
                                                        key={this.formKey}

                                                        field="columnField"
                                                        defaultValue={this.defaultValues("columnField")}
                                                        options={modifiedFields}
                                                        isMulti
                                                        menuIsOpen={true} //keep menu always open
                                                    />
                                                    <div style={{ marginTop: 324 }}>
                                                        <Typography variant="h7" className={classes.flex} fullWidth>
                                                            Note: selected 'column' fields will be removed from the list as they are selected.
                                                        </Typography>
                                                    </div>
                                                    <div style={{ marginTop: 5, color: "red" }}>
                                                        <Typography variant="h7" className={classes.flex}>
                                                            To consolidate table column results by name, select all desired form fields with a common
                                                            name.{" "}
                                                        </Typography>
                                                    </div>
                                                    {(isPointGeo && (
                                                        <Grid xs={5} item>
                                                            <Switch
                                                                field="showlatloncolumns"
                                                                name="showlatloncolumns"
                                                                label={
                                                                    <HelpLabel
                                                                        inputLabel="Show Lat/Lon fields in an xls download?"
                                                                        helpText="Select 'Yes' to include lat and lon fields within download of the xls table results. This option will only return 'primary' section lat/lon map values and the section geometry configuration must be set as 'Point'. Note: this feature is not compatible with table result fields that are master contacts."
                                                                    />
                                                                }
                                                            />
                                                        </Grid>
                                                    )
                                                    )}

                                                </Grid>
                                            </Grid>
                                        )}
                                        {value === 1 && (
                                            <Grid container style={{ paddingTop: 20, paddingLeft: 16, paddingRight: 16 }}>
                                                <Grid item xs={12}>
                                                    <Typography variant="h5" className={classes.flex}>
                                                        Statistic Fields
                                                    </Typography>
                                                    <ReactSelect
                                                        key={this.formKey}
                                                        field="statisticField"
                                                        defaultValue={this.defaultValues("statisticField")}
                                                        options={modifiedFields}
                                                        isMulti
                                                        menuIsOpen={true} //keep menu always open
                                                    />
                                                    <div style={{ marginTop: 324 }}>
                                                        <Typography variant="h7" className={classes.flex}>
                                                            Note: statistic fields can 'only' be Numeric, Currency or Calculated field 'data types'
                                                            for proper statistic calculations.
                                                        </Typography>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        )}
                                        {value === 2 && (
                                            <Grid container style={{ paddingTop: 20, paddingLeft: 16, paddingRight: 16 }}>
                                                {!moduleAnalyticsOnly && (
                                                    <Grid container alignItems="center" style={{ marginBottom: 4 }}>
                                                        <Grid item style={{ flexGrow: 1, marginLeft: 14 }}>
                                                            <Switch
                                                                field="analytics_view"
                                                                name="repeatable"
                                                                label={
                                                                    <HelpLabel
                                                                        key={key}
                                                                        inputLabel="Include Card(s) on Module Dashboard?"
                                                                        helpText={`If Yes, select fields to appear and also identify the Statistic Type along with other options below. Cards are displayed on the Dashboard.

                                                                                                        The fields available for Cards are limited to those fields selected in the "Results Display Setting" section of the settings to appear as columns in the results table.`}
                                                                    />
                                                                }
                                                                eventHandle={(e) => {
                                                                    ormAdvancedSearchUpdate({ id: advancedsearchID[0].id, analytics_view: e });
                                                                    this.setState({ showCards: e });
                                                                }}
                                                            />
                                                        </Grid>
                                                        {showCards && (
                                                            <Grid item style={{ paddingRight: 8 }}>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() => this.setState({ createGroupDialogOpen: true })}
                                                                    style={{ borderRadius: 5 }}>
                                                                    <AddIcon className={classes.iconAdd} />&nbsp;&nbsp;&nbsp;New Group
                                                                </Button>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                )}

                                                <Grid item xs={12}>
                                                    {!showCards && (
                                                        <>
                                                            <br></br>
                                                            <Typography
                                                                variant="h5"
                                                                style={{ color: "red", fontSize: 18, textDecoration: "underline", marginLeft: 12 }}>
                                                                Cards will not be shown on the Dashboard.
                                                            </Typography>
                                                        </>
                                                    )}
                                                    {showCards && (
                                                        <>
                                                            {/* ── Group Accordions ── */}
                                                            {analyticsGroups.map((group) => (
                                                                <Accordion key={group.id} defaultExpanded={true} style={{ marginBottom: 6 }}>
                                                                    <AccordionSummary
                                                                        expandIcon={<ExpandMoreIcon style={{ color: group.header_font_color || '#66686a' }} />}
                                                                        className={classes.titlePanel}
                                                                        classes={{ root: classes.expandedMargin }}
                                                                        style={{ backgroundColor: group.header_color || "#cbcbcb", borderRadius: 3, boxShadow: "rgba(0,0,0,0.2) 0px 1px 1px" }}>
                                                                        <table style={{ width: "100%" }}>
                                                                            <tr>
                                                                                <td style={{ width: "100%" }}>
                                                                                    <Typography variant="h5" style={{ fontSize: 16, color: group.header_font_color || "black" }}>
                                                                                        {group.name}
                                                                                    </Typography>
                                                                                </td>
                                                                                <td style={{ whiteSpace: 'nowrap' }}>
                                                                                    <Tooltip title="Rename Group">
                                                                                        <IconButton size="small" onClick={(e) => { e.stopPropagation(); this.setState({ renameGroupOpen: true, groupToRename: group, renameGroupValue: group.name, renameGroupColor: group.header_color || '#cbcbcb', renameGroupFontColor: group.header_font_color || '#66686a' }); }} style={{ color: group.header_font_color || '#66686a' }}>
                                                                                            <EditIcon fontSize="small" />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                    {group.cards.length === 0 && (
                                                                                        <Tooltip title="Delete Group">
                                                                                            <IconButton
                                                                                                size="small"
                                                                                                onClick={(e) => { e.stopPropagation(); this.setState({ deleteGroupDialogOpen: true, groupToDelete: group }); }}
                                                                                                style={{ color: group.header_font_color || '#66686a' }}>
                                                                                                <DeleteIcon fontSize="small" />
                                                                                            </IconButton>
                                                                                        </Tooltip>
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </AccordionSummary>
                                                                    <AccordionDetails style={{ padding: 0, display: 'block' }}>
                                                                        <div style={{ margin: '6px 8px 8px 8px', border: '1px solid #ccc', borderRadius: 4, overflow: 'hidden' }}>
                                                                            {!moduleAnalyticsOnly && (
                                                                                <Button
                                                                                    fullWidth
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    onClick={() => {
                                                                                        const order = group.cards.length;
                                                                                        ormPageAnalyticsCreate({ advancedsearch_id: advancedsearchID[0].id, order, analytics_dashboard_group: group.id }).then(
                                                                                            (e) => { this.setState({ open_analytic: true, analyticToEdit: e, chartOptions: false, chart_Type: "" }); }
                                                                                        );
                                                                                    }}
                                                                                    style={{ borderRadius: 0, marginBottom: 0 }}
                                                                                >
                                                                                    <AddIcon className={classes.iconAdd} />&nbsp;&nbsp;&nbsp;Create New Card in "{group.name}"
                                                                                </Button>
                                                                            )}
                                                                            <DragDropContext onDragEnd={(result) => this.handleGroupDragEnd(result, group.cards)}>
                                                                                <Droppable droppableId={`group_${group.id}`} type="analytics_list">
                                                                                    {(provided, snapshot) => (
                                                                                        <div ref={provided.innerRef} style={getListStyle2(snapshot.isDraggingOver)}>
                                                                                            <div style={{ overflowX: "auto" }}>
                                                                                                {/* Column header */}
                                                                                                <div style={{ display: "flex", marginLeft: 14, marginRight: 14, backgroundColor: "#333", marginBottom: 2 }}>
                                                                                                    <div style={{ flex: "0 0 140px" }}><Typography style={{ fontSize: 14, color: '#fff', marginLeft: 60 }}>Actions</Typography></div>
                                                                                                    <div style={{ flex: "150 1 0px", minWidth: 90, overflow: "hidden" }}><Typography style={{ fontSize: 14, color: '#fff' }}>Analytic Card Label</Typography></div>
                                                                                                    <div style={{ flex: "190 1 0px", minWidth: 80, overflow: "hidden" }}><Typography style={{ fontSize: 14, color: '#fff' }}>Saved Search</Typography></div>
                                                                                                    <div style={{ flex: "150 1 0px", minWidth: 60, overflow: "hidden" }}><Typography style={{ fontSize: 14, color: '#fff' }}>Searched Field Name</Typography></div>
                                                                                                    <div style={{ flex: "150 1 0px", minWidth: 100, overflow: "hidden" }}><Typography style={{ fontSize: 14, color: '#fff' }}>Move to Group</Typography></div>
                                                                                                    <div style={{ flex: "0 0 70px", textAlign: 'center' }}><Typography style={{ fontSize: 14, color: '#fff' }}>Visible</Typography></div>
                                                                                                </div>
                                                                                                {group.cards.length === 0 && (
                                                                                                    <Typography style={{ padding: '10px 0', color: '#888', fontSize: 13, textAlign: 'center' }}>
                                                                                                        No Cards Available
                                                                                                    </Typography>
                                                                                                )}
                                                                                                <div style={{ marginTop: -3, marginBottom: -3, fontSize: "initial" }}>
                                                                                                    {group.cards.map((n, idx) => {
                                                                                                        var fieldName; // eslint-disable-next-line
                                                                                                        if (modifiedFields) modifiedFields.find((j) => { j.options.find((k) => { if (k.value === parseInt(n.field)) { fieldName = k.label; } }); });
                                                                                                        return (
                                                                                                            <Draggable key={n.id} draggableId={n.id.toString()} index={idx} isDragDisabled={!authState.user.is_city_admin}>
                                                                                                                {(provided, snapshot) => (
                                                                                                                    <div key={n.id} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyle2(snapshot.isDragging, provided.draggableProps.style)} className={classes.fieldButton}>
                                                                                                                        <div style={{ display: "flex" }}>
                                                                                                                            <div style={{ flex: "0 0 140px", whiteSpace: "nowrap" }}>
                                                                                                                                <img style={{ width: "1.5em", height: "1.6em", verticalAlign: "middle", marginRight: 11, marginLeft: 6 }} src={drag} alt="drag" />
                                                                                                                                {advancedsearchID[0] && n.advancedsearch === advancedsearchID[0].id ? (
                                                                                                                                    <Tooltip title="Edit">
                                                                                                                                        <Button onClick={() => { this.setState({ open_analytic: true, analyticToEdit: n, chartOptions: n.chart === true, chart_Type: n.chart_type || "" }); this.props.handleDialog(); }} className={classes.deleteWidth}>
                                                                                                                                            <EditIcon color="primary" />
                                                                                                                                        </Button>
                                                                                                                                    </Tooltip>
                                                                                                                                ) : (
                                                                                                                                    <Tooltip title="
                                                                                                                                        This card belongs to another search and cannot be edited here. 
                                                                                                                                        To edit this card click on the blue search hyperlink
                                                                                                                                     ">
                                                                                                                                        <span>
                                                                                                                                            <Button disabled className={classes.deleteWidth}>
                                                                                                                                                <EditIcon />
                                                                                                                                            </Button>
                                                                                                                                        </span>
                                                                                                                                    </Tooltip>
                                                                                                                                )}
                                                                                                                                <Tooltip title="Delete">
                                                                                                                                    <Button onClick={() => this.setState({ deleteDialogOpen: true, analyticToDelete: n })} className={classes.deleteWidth}>
                                                                                                                                        <DeleteIcon color="inherit" />
                                                                                                                                    </Button>
                                                                                                                                </Tooltip>
                                                                                                                            </div>
                                                                                                                            <div style={{ flex: "150 1 0px", minWidth: 90, overflow: "hidden" }}>
                                                                                                                                <Tooltip title={n.card_label || ""}>
                                                                                                                                    <Typography noWrap style={{ fontSize: 14 }}>{n.card_label ? n.card_label : "-"}</Typography>
                                                                                                                                </Tooltip>
                                                                                                                            </div>
                                                                                                                            <div style={{ flex: "190 1 0px", minWidth: 80, overflow: "hidden" }}>
                                                                                                                                {((moduleAnalyticsOnly || (advancedsearchID[0] && n.advancedsearch !== advancedsearchID[0].id)) && n.search_page && n.advancedsearch) ? (
                                                                                                                                    <Tooltip title={`Open "${n.search_name}" in a new tab to edit`}>
                                                                                                                                        <a href={`/#/page/${n.search_page}/advancedsearch/${n.advancedsearch}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                                                                                                                            <Typography noWrap style={{ fontSize: 14, color: '#1976d2', fontStyle: 'italic', textDecoration: 'underline', cursor: 'pointer' }}>
                                                                                                                                                {n.search_name}
                                                                                                                                            </Typography>
                                                                                                                                        </a>
                                                                                                                                    </Tooltip>
                                                                                                                                ) : (
                                                                                                                                    <Tooltip title={n.search_name || ""}>
                                                                                                                                        <Typography noWrap style={{ fontSize: 14 }}>
                                                                                                                                            {n.search_name ? n.search_name : "-"}
                                                                                                                                        </Typography>
                                                                                                                                    </Tooltip>
                                                                                                                                )}
                                                                                                                            </div>
                                                                                                                            <div style={{ flex: "150 1 0px", minWidth: 60, overflow: "hidden" }}>
                                                                                                                                <Tooltip title={fieldName || ""}>
                                                                                                                                    <Typography noWrap style={{ fontSize: 14 }}>{fieldName ? fieldName : "-"}</Typography>
                                                                                                                                </Tooltip>
                                                                                                                            </div>
                                                                                                                            <div style={{ flex: "150 1 0px", minWidth: 100, overflow: "hidden" }}>
                                                                                                                                <NativeSelect
                                                                                                                                    value={group.id}
                                                                                                                                    onChange={(e) => ormPageAnalyticsUpdate({ id: n.id, analytics_dashboard_group: parseInt(e.target.value) || null })}
                                                                                                                                    style={{ fontSize: 12, minWidth: 80, maxWidth: "100%" }}>
                                                                                                                                    {analyticsGroups.map((g) => (
                                                                                                                                        <option key={g.id} value={g.id}>{g.name}</option>
                                                                                                                                    ))}
                                                                                                                                </NativeSelect>
                                                                                                                            </div>
                                                                                                                            <div style={{ flex: "0 0 70px", textAlign: 'center' }}>
                                                                                                                                <Tooltip title={n.show_on_dashboard !== false ? "Hide from Dashboard" : "Show on Dashboard"}>
                                                                                                                                    <input
                                                                                                                                        type="checkbox"
                                                                                                                                        checked={n.show_on_dashboard !== false}
                                                                                                                                        onChange={() => ormPageAnalyticsUpdate({ id: n.id, show_on_dashboard: n.show_on_dashboard === false })}
                                                                                                                                        style={{ width: 16, height: 16, cursor: 'pointer' }}
                                                                                                                                    />
                                                                                                                                </Tooltip>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            </Draggable>
                                                                                                        );
                                                                                                    })}
                                                                                                </div>
                                                                                                {provided.placeholder}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </Droppable>
                                                                            </DragDropContext>
                                                                        </div>
                                                                    </AccordionDetails>
                                                                </Accordion>
                                                            ))}

                                                            <Grid container style={{ marginTop: 8 }}>
                                                                <Grid item xs={12}>
                                                                    <Typography variant="h5" style={{ fontSize: 14, marginLeft: 4, color: "#e90909" }}>
                                                                        Drag and drop cards within the table above to reorder their positional view on the dashboard.
                                                                        {analyticsGroups.length >= 2 && " Cards can be moved into other groups by selecting and changing the group within each card."}
                                                                    </Typography>
                                                                    {analyticsGroups.some(g => g.cards.some(c => advancedsearchID[0] && c.advancedsearch !== advancedsearchID[0].id)) && (
                                                                        <Typography variant="h5" style={{ fontSize: 14, marginLeft: 4, marginTop: 4, color: "#888" }}>
                                                                            Cards with an underlined blue search name belong to another search. Click the search name to open that search in a new tab where the card can be edited.
                                                                        </Typography>
                                                                    )}
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        )}
                                        {value === 3 && (
                                            <Grid
                                                container
                                                style={{
                                                    paddingTop: 24,
                                                    paddingLeft: 16,
                                                    paddingRight: 16,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        backgroundColor: "#d3d3d3",
                                                        width: "100%",
                                                        paddingBottom: 17,
                                                        borderRadius: 4,
                                                    }}>
                                                    <Typography
                                                        variant="h6"
                                                        className={classes.flex}
                                                        style={{
                                                            // fontSize: 16,
                                                            // marginBottom: 7,
                                                            // paddingLeft: 5,
                                                            // color: "#fff",
                                                            // background: "#191919", // "#673ab7",
                                                            // borderRadius: 4,
                                                            // paddingTop: 4,
                                                            // paddingBottom: 4,
                                                            fontSize: 16,
                                                            marginBottom: 7,
                                                            paddingLeft: 12,
                                                            color: "#fff",
                                                            background: "#191919",
                                                            paddingTop: 4,
                                                            paddingBottom: 4,
                                                        }}
                                                    >
                                                        Group Display: Choose a New 'or' Existing Group to display this Saved Search
                                                    </Typography>
                                                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, padding: '0 8px 12px 8px' }}>
                                                        <div style={{ flex: '45 1 0px', minWidth: 0 }}>
                                                            <TextField
                                                                field="g_name"
                                                                fullWidth
                                                                style={{ width: '100%' }}
                                                                label={
                                                                    <HelpLabel
                                                                        inputLabel="Create a New Group?"
                                                                        helpText="The Saved Search will be grouped under this name. Leave this field blank if you want to place this search within an existing Saved Search Group."
                                                                    />
                                                                }
                                                            />
                                                        </div>
                                                        <Typography variant="h5" style={{ flex: '0 0 auto', fontSize: 21, paddingBottom: 6, color: '#555' }}>
                                                            (OR)
                                                        </Typography>
                                                        <div style={{ flex: '45 1 0px', minWidth: 0 }}>
                                                            <Select
                                                                field="group_name"
                                                                fullWidth
                                                                style={{ width: '100%' }}
                                                                options={this.dropDownValues(
                                                                    advancedgroups.map((g) => {
                                                                        return g.name;
                                                                    })
                                                                )}
                                                                label={
                                                                    <HelpLabel
                                                                        inputLabel="Current Group?"
                                                                        helpText="This Saved Search will reside in the selected Group."
                                                                    />
                                                                }
                                                                onChange={(e) => this.relay(e)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <Typography
                                                        variant="h6"
                                                        className={classes.flex}
                                                        style={{
                                                            fontSize: 16,
                                                            marginBottom: 7,
                                                            paddingLeft: 12,
                                                            color: "#fff",
                                                            background: "#191919",
                                                            paddingTop: 4,
                                                            paddingBottom: 4,
                                                        }}
                                                    >
                                                        Expansion Bar Color: Select the Color of the Search Bar on the Dashboard
                                                    </Typography>
                                                    <Grid container style={{ paddingLeft: "20%" }}>
                                                        <Grid
                                                            item
                                                            xs={5}
                                                            style={{
                                                                marginBottom: 7,
                                                                paddingLeft: 12,
                                                            }}>
                                                            <ColorPicker field="expansion_color" label="Expansion Bar Color" />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={5}
                                                            style={{
                                                                marginBottom: 7,
                                                            }}>
                                                            <ColorPicker field="expansion_font_color" label="Expansion Font Color" />
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                                <div style={{ display: 'flex', gap: 8, padding: '12px 8px 0 8px', width: '100%' }}>
                                                    <div style={{ flex: '1 1 0px', minWidth: 0 }}>
                                                        <Select
                                                            field="editableby"
                                                            fullWidth
                                                            options={this.dropDownValues(edit_access)}
                                                            label={
                                                                <HelpLabel
                                                                    inputLabel="Edit Privileges?"
                                                                    helpText="Select the user type that can edit this search.  Note: the 'Creator' selection is the user that selected this setting."
                                                                />
                                                            }
                                                        />
                                                    </div>
                                                    <div style={{ flex: '1 1 0px', minWidth: 0 }}>
                                                        <Select
                                                            field="accessby"
                                                            fullWidth
                                                            options={this.dropDownValues(accessibility)}
                                                            label={
                                                                <HelpLabel
                                                                    inputLabel="Accessibility?"
                                                                    helpText="Select who can view this search. Note: the 'Creator' is the person that 'Saved' the search with this setting being set."
                                                                />
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                {/* <Grid item xs={11} style={{ marginLeft: 20, marginTop: 15 }}> */}
                                                {/*                                                      */}
                                                {/* </Grid> */}
                                                {(() => {
                                                    const showMapColor = has_geometry && formApi.getValue('geometriesonmap');
                                                    return (
                                                        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: showMapColor ? 'space-between' : 'flex-start', padding: '4px 8px 8px 8px', width: '100%' }}>
                                                            <div style={showMapColor ? {} : { flex: '1 1 0px' }}>
                                                                <Switch
                                                                    field="dashboard"
                                                                    name="dashboard"
                                                                    label={
                                                                        <HelpLabel
                                                                            inputLabel="Show on Dashboard?"
                                                                            helpText="Select 'Yes' to show this Saved Search on the dashboard."
                                                                        />
                                                                    }
                                                                />
                                                            </div>
                                                            {has_geometry && (
                                                                <div style={showMapColor ? {} : { flex: '1 1 0px' }}>
                                                                    <Switch
                                                                        field="geometriesonmap"
                                                                        name="geometriesonmap"
                                                                        label={
                                                                            <HelpLabel
                                                                                inputLabel="Show Geometry on Map?"
                                                                                helpText="Select 'Yes' to show this Saved Search Geometries on the Map."
                                                                            />
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                            {showMapColor && (
                                                                <div style={{ paddingBottom: 4 }}>
                                                                    <ColorPicker field="geo_color" label="Search Map Layer Color" />
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })()}
                                            </Grid>
                                        )}
                                        {value !== 2 && (
                                            <DialogActions>
                                                <Button type="submit" variant="contained" color="primary" size="large">
                                                    Save
                                                </Button>
                                            </DialogActions>
                                        )}
                                    </form>
                                )}
                            </Formm>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
                <Dialog open={open_analytic} classes={{ paper: classes.minWidth2 }} disableBackdropClick={true}>
                    <Toolbar style={{ backgroundColor: "#d3d3d3" }}>
                        <Typography variant="h5" className={classes.flex}>
                            Card Settings
                        </Typography>
                        <IconButton onClick={() => this.setState({ open_analytic: false })}>
                            <Close />
                        </IconButton>
                    </Toolbar>
                    <DialogContent>
                        <DialogContentText>
                            <Formm
                                getApi={(el) => (this.formApi = el)} //allows use of this.formApi ref external of form
                                defaultValues={this.defaultAnalytic()}
                                validateError={this.errorValidator}
                                dontValidateOnMount="true"
                                onSubmit={(values) => this.saveAnalytic(values)}>
                                {(formApi) => (
                                    <form onSubmit={formApi.submitForm}>
                                        <Grid container style={{ paddingTop: 20 }}>
                                            <Grid item xs={12}>
                                                {/* default values are passed to the reactSelect component for rendering*/}
                                                <ReactSelect
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Select Field:"
                                                            helpText={`Choose the field to display a statistic value on the Card. 
                                                            
                                                            Only fields selected as column on the results table are available.`}
                                                        />
                                                    }
                                                    field="field"
                                                    defaultValue={this.defaultAnalytic("AnalyticField")}
                                                    options={analyticFields}
                                                    eventHandle={(e) => {
                                                        return (
                                                            ormPageAnalyticsUpdate({ id: analyticToEdit.id, field: e.value, field_type: e.type }),
                                                            this.setState({ fieldType: e.type })
                                                        );
                                                    }}
                                                />
                                                <TextField
                                                    field="card_label"
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Card Label Text:"
                                                            helpText={"Enter text that will appear as a label alongside the statistical value"}
                                                        />
                                                    }
                                                    style={{ marginTop: 28 }}
                                                    fullWidth
                                                />
                                                <Select
                                                    field="stat_type"
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Statistic Type:"
                                                            helpText={`Choose the statistic to be calculated and displayed on the Card. 
                                                            
                                                            If the selected field is not a Numeric, Currency or Calculated field type, only the Count type will be available.`}
                                                        />
                                                    }
                                                    options={this.dropDownValues(statType)}
                                                    style={{ marginTop: 28 }}
                                                    fullWidth
                                                />
                                                <hr style={{ marginTop: 17 }} />
                                                <Grid container style={{ marginTop: 5 }}>
                                                    <Grid xs={4}>
                                                        <ColorPicker field="card_header_bgcolor" label="Header Background Color" />
                                                    </Grid>
                                                    <Grid xs={4}>
                                                        <ColorPicker field="card_header_txtcolor" label="Header Text Color" />
                                                    </Grid>
                                                    <Grid xs={4}>
                                                        <ColorPicker field="stat_color" label="Value Text Color" />
                                                    </Grid>
                                                </Grid>
                                                <hr style={{ marginTop: 17 }} />

                                                <div style={{ marginBottom: 12 }}>
                                                    <Checkbox
                                                        field="chart"
                                                        label={
                                                            <HelpLabel
                                                                inputLabel="Include Chart?"
                                                                helpText="Select yes to include a chart along with the statistical value on the Card."
                                                            />
                                                        }
                                                        eventHandle={(val) => {
                                                            return val === true
                                                                ? (ormPageAnalyticsUpdate({ id: analyticToEdit.id, chart: true }),
                                                                    this.setState({ chartOptions: true }))
                                                                : (ormPageAnalyticsUpdate({
                                                                    id: analyticToEdit.id,
                                                                    chart: false,
                                                                    chart_type: "None",
                                                                    field2: 0,
                                                                    field2_type: "None",
                                                                    cumulative: false,
                                                                    field_value: "",
                                                                    goal_value: 0,
                                                                    time_increment: "",
                                                                    time_series_type: "Bar",
                                                                }), //now reset form incase they dont save
                                                                    this.formApi.setValue("chart_type", "None"),
                                                                    this.formApi.setValue("field2", 0),
                                                                    this.formApi.setValue("field2_type", "None"),
                                                                    this.formApi.setValue("cumulative", false),
                                                                    this.formApi.setValue("field_value", ""),
                                                                    this.formApi.setValue("goal_value", 0),
                                                                    this.formApi.setValue("time_increment", ""),
                                                                    this.formApi.setValue("time_series_type", "Bar"),
                                                                    this.setState({ chartOptions: "", chart_Type: "" })); // chartOptions/chart_Type kept for legacy; visibility now driven by formApi
                                                        }}
                                                    />
                                                </div>
                                                {formApi.getValue('chart') && (
                                                    <Select
                                                        field="chart_type"
                                                        label={
                                                            <HelpLabel
                                                                inputLabel="Chart Type:"
                                                                helpText={
                                                                    "Choose the type of chart to display on the card. Selections are Gauge or Time Series."
                                                                }
                                                            />
                                                        }
                                                        options={this.chartType(chartTypes)}
                                                        fullWidth
                                                        eventHandle={(val) => {
                                                            ormPageAnalyticsUpdate({ id: analyticToEdit.id, chart_type: val });
                                                        }}
                                                    />
                                                )}
                                                {formApi.getValue('chart_type') === "Gauge" && (
                                                    <>
                                                        <TextField
                                                            field="goal_value"
                                                            label={
                                                                <HelpLabel
                                                                    inputLabel="Goal Value:"
                                                                    helpText={"Enter a numeric value to set the upper limit on the gauge chart"}
                                                                />
                                                            }
                                                            fullWidth
                                                            style={{ marginTop: 15 }}
                                                        />

                                                        <ColorPicker field="progress_color" label="Chart Color:" />
                                                    </>
                                                )}

                                                {formApi.getValue('chart_type') === "Time Series" && (
                                                    /*fieldType === "Date" &&*/ <div
                                                        style={{
                                                            backgroundColor: "#d3d3d3",
                                                            paddingLeft: 10,
                                                            marginLeft: -9,
                                                            marginRight: -9,
                                                            paddingRight: 10,
                                                            paddingBottom: 17,
                                                            paddingTop: 16,
                                                            borderRadius: 5,
                                                            zIndex: 10000,
                                                            marginTop: 14,
                                                        }}>
                                                        <Typography
                                                            style={{ fontSize: 13, color: "#da0014", marginBottom: 13 }}
                                                            className={classes.flex}>
                                                            {`Time Series charts must have a Date field from the 'Results Display 
                                                            Settings' in order to select a 'Date Value Field' on the chart.
                                                      `}
                                                        </Typography>
                                                        <ReactSelect
                                                            label={
                                                                <HelpLabel
                                                                    inputLabel="Select Date Value Field:"
                                                                    helpText={`Choose the date field to use on the time series chart. Only the fields selected to display on the search results table are available.`}
                                                                />
                                                            }
                                                            field={"field2"}
                                                            defaultValue={this.defaultAnalytic("AnalyticField2")}
                                                            options={analyticFields2}
                                                            eventHandle={(e) => {
                                                                return e !== " "
                                                                    ? (ormPageAnalyticsUpdate({
                                                                        id: analyticToEdit.id,
                                                                        field2: e.value,
                                                                        field2_type: e.type,
                                                                    }),
                                                                        this.formApi.setValue("field2_type", e.type))
                                                                    : ormPageAnalyticsUpdate({
                                                                        id: analyticToEdit.id,
                                                                        field2: 0,
                                                                        field2_type: null,
                                                                    });
                                                                // this.setState({ field2Type: e.type });
                                                            }}
                                                        />
                                                        <Select
                                                            field="time_series_type"
                                                            label={
                                                                <HelpLabel
                                                                    inputLabel="Time Series Type:"
                                                                    helpText={"Choose 'Bar' or 'Time Series' chart"}
                                                                />
                                                            }
                                                            options={this.timeSeries(timeSeriesType)}
                                                            fullWidth
                                                            style={{ marginTop: 15 }}
                                                        />

                                                        <Select
                                                            style={{ marginTop: 15 }}
                                                            field="time_increment"
                                                            label={
                                                                <HelpLabel
                                                                    inputLabel="Time Increment:"
                                                                    helpText={`Considering the limited chart size on the Module Analytics View, the following guidelines are suggested when choosing the Time Increment for the x-axis.

                                                                        -Daily - Do not display more than a 1 month period.
                                                                        -Weekly - Do not display more than a 3 month period.
                                                                        -Monthly - Do not display more than a 1 year period.
                                                                        -Quarterly - Do not display more than a 1 year period.
                                                                        -Annually - Do not display more than a 10 year period.
                                                                        
                                                                        The start and end time of the x-axis are dynamically determined from the Search Fields. To reduce or extend the time period shown on the x-axis, adjust the Search Field criteria.`}
                                                                />
                                                            }
                                                            options={this.timeSeries(timeToIncrement)}
                                                            fullWidth
                                                        />
                                                        <Checkbox
                                                            field="cumulative"
                                                            label={
                                                                <HelpLabel
                                                                    inputLabel="Is Chart Cumulative?"
                                                                    helpText="Values will be cumulative on the time series chart if checked."
                                                                />
                                                            }
                                                        />
                                                        <TextField
                                                            style={{ marginTop: 15 }}
                                                            field="goal_value"
                                                            label={
                                                                <HelpLabel
                                                                    inputLabel="Goal Value:"
                                                                    helpText={
                                                                        "Enter a numeric value to set the upper limit on the bar or time series chart"
                                                                    }
                                                                />
                                                            }
                                                            fullWidth
                                                        />
                                                        <ColorPicker field="progress_color" label="Chart Color:" />
                                                    </div>
                                                )}

                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    style={{ marginTop: 29, width: "21%", float: "right" }}>
                                                    Save
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                )}
                            </Formm>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
                <WarningDialog
                    confirmAction={() => {
                        ormPageAnalyticsDelete(analyticToDelete.id);
                        this.setState({ deleteDialogOpen: false });
                    }}
                    cancelAction={() => this.setState({ deleteDialogOpen: false })}
                    open={deleteDialogOpen}
                    title="Delete Analytic Card?"
                    text={`Are you sure you wish to permanently delete '${analyticToDelete ? analyticToDelete.card_label : null}' ?`}
                />

                {/* Create New Group Dialog */}
                <Dialog open={createGroupDialogOpen} onClose={() => this.setState({ createGroupDialogOpen: false })}>
                    <Toolbar style={{ backgroundColor: "#d3d3d3" }}>
                        <Typography variant="h5" style={{ flex: 1 }}>Create Analytics Group</Typography>
                        <IconButton onClick={() => this.setState({ createGroupDialogOpen: false })}><Close /></IconButton>
                    </Toolbar>
                    <DialogContent style={{ minWidth: 360, paddingTop: 20 }}>
                        <input
                            autoFocus
                            placeholder="Group name"
                            value={newGroupName}
                            onChange={(e) => this.setState({ newGroupName: e.target.value })}
                            onKeyDown={(e) => { if (e.key === 'Enter') this.handleCreateGroup(); }}
                            style={{ width: '100%', padding: '8px', fontSize: 16, marginBottom: 16, boxSizing: 'border-box', border: '1px solid #ccc', borderRadius: 4 }}
                        />
                        <Button fullWidth variant="contained" color="primary" onClick={this.handleCreateGroup}>
                            Create Group
                        </Button>
                    </DialogContent>
                </Dialog>

                {/* Rename Group Dialog */}
                <Dialog open={renameGroupOpen} onClose={() => this.setState({ renameGroupOpen: false })}>
                    <Toolbar style={{ backgroundColor: "#d3d3d3" }}>
                        <Typography variant="h5" style={{ flex: 1 }}>Edit Group</Typography>
                        <IconButton onClick={() => this.setState({ renameGroupOpen: false })}><Close /></IconButton>
                    </Toolbar>
                    <DialogContent style={{ minWidth: 360, paddingTop: 20 }}>
                        <input
                            autoFocus
                            value={renameGroupValue}
                            onChange={(e) => this.setState({ renameGroupValue: e.target.value })}
                            onKeyDown={(e) => { if (e.key === 'Enter') this.handleRenameGroup(); }}
                            style={{ width: '100%', padding: '8px', fontSize: 16, marginBottom: 16, boxSizing: 'border-box', border: '1px solid #ccc', borderRadius: 4 }}
                        />
                        {authState.user.is_city_admin && (
                            <div style={{ marginBottom: 16 }}>
                                <div style={{ display: 'flex', alignItems: 'center', height: 40, marginBottom: 4 }}>
                                    <Typography style={{ fontSize: 14, marginRight: 8, lineHeight: 1, minWidth: 130 }}>Group Header Color:</Typography>
                                    <div className={classes.colorPickerCenter}>
                                        <MuiColorPicker
                                            value={renameGroupColor || false}
                                            onChange={(value) => this.setState({ renameGroupColor: typeof value.raw === "string" ? value.raw : "#" + value.hex })}
                                            disableTextfield
                                        />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', height: 40 }}>
                                    <Typography style={{ fontSize: 14, marginRight: 8, lineHeight: 1, minWidth: 130 }}>Group Font Color:</Typography>
                                    <div className={classes.colorPickerCenter}>
                                        <MuiColorPicker
                                            value={renameGroupFontColor || false}
                                            onChange={(value) => this.setState({ renameGroupFontColor: typeof value.raw === "string" ? value.raw : "#" + value.hex })}
                                            disableTextfield
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        <Button fullWidth variant="contained" color="primary" onClick={this.handleRenameGroup}>
                            Save Name
                        </Button>
                    </DialogContent>
                </Dialog>

                {/* Delete Group Confirmation */}
                <WarningDialog
                    confirmAction={this.handleDeleteGroup}
                    cancelAction={() => this.setState({ deleteGroupDialogOpen: false, groupToDelete: null })}
                    confirmText="Delete Group"
                    open={deleteGroupDialogOpen}
                    title="Delete Analytics Group?"
                    text={`Are you sure you want to delete '${groupToDelete ? groupToDelete.name : ''}'?`}
                />
            </div>
        );
    }
}
AdvancedSearchSettings.displayName = "AdvancedSearchSettings";

AdvancedSearchSettings = connect(
    (state, ownProps) => ({
        has_geometry: getGeometry(state, ownProps),
        contact_fields: getAllContactFields(state, ownProps),
        advancedsearch: getPageAnalytics(state, ownProps),
        analyticsGroups: getAnalyticsGroups(state, ownProps),
    }),
    { ...RecordSection.actions, ...PageAnalytics.actions, ...AnalyticsGroup.actions }
)(AdvancedSearchSettings);

export default withStyles(styles, { withTheme: true })(withRouter(AdvancedSearchSettings));
